/**
 * Session expirée / token invalide : déconnexion.
 *
 * Même comportement que sur les pages Simulations : on vide le localStorage
 * (token, idAgent, exploitation...) puis retour à l'accueil. C'est un
 * rechargement complet de la page ('/'), car ce code tourne hors composant
 * React (pas de navigate() disponible).
 *
 * Seuls 401 (non authentifié / token expiré) et 403 (token refusé) déclenchent
 * la déconnexion : une 500 ou un 404 (route pas encore prête côté API) ne doit
 * pas jeter l'utilisateur dehors.
 *
 * @param response  la Response renvoyée par fetch
 * @throws Error    après avoir lancé la redirection, pour interrompre l'appelant
 */
export function deconnecterSiTokenInvalide(response) {
  if (response.status === 401 || response.status === 403) {
    localStorage.clear();
    window.location.replace('/');
    throw new Error('Session expirée : déconnexion');
  }
}
